<template>
  <div>
    <label for="searchquery" class="h4">{{ textLabel }}</label>
    <input
      id="searchquery"
      :placeholder="textPlaceholder"
      @keyup="setFilter"
      type="text"
      class="form-control w-100 rounded shadow-sm"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import debounce from "lodash/debounce";

export default {
  name: "CampaignsProductNameFilterInput",
  props: {
    textPlaceholder: {
      type: String,
      required: true,
    },
    textLabel: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      productNameFilter: "lists/getProductNameFilter",
    }),
  },
  methods: {
    ...mapActions({ setProductNameFilter: "lists/setProductNameFilter" }),
    setFilter: debounce(function(e) {
      this.setProductNameFilter(e.target.value);
    }, 500),
  },
};
</script>
